module.exports = __webpack_public_path__ + "assets/img/rsc.18b9edc1.png";